import { FormMemberResponse } from 'src/modules/member/models/formMemberResponse';
import { WebFormMemberPost } from 'src/modules/member/models/webFormMemberPost';
import AxiosInstance from 'src/shared/services/axios/interceptor';

const controller = 'WebFormMember';

export const getNewWebFormMember = (custName) => {
  const endpoint = `${controller}/new/?custName=${custName}&formName=webform`;
  return AxiosInstance.get<FormMemberResponse>(endpoint);
};

export const createWebFormMember = (member: WebFormMemberPost) => {
  const endpoint = `${controller}`;
  return AxiosInstance.post<WebFormMemberPost>(endpoint, member);
};
